import React from 'react';

import Icon from './Icon';
import {Button} from "./Button";
//import createLink from "../../libs/createLink";
import ModalSubscription from "../components/ModalSubscription";
import history from "../../libs/history";
import Modal from "./Modal";
import {bindActionCreators} from "redux";
//import {logoutUser} from "../../reducers2/login";
//import {fetchUnreadRooms} from "../../creators/user.unreadRooms";
//import {fetchUnreadNotifications} from "../../creators/user.unreadNotification";
//import {markAllUserNotificationsOpen} from "../../creators/user.notifications";
import {connect} from "react-redux";

class Subscribe extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscription : false
        };

        this.onClickModalSubscription = this.onClickModalSubscription.bind(this);
    }

    onClickModalSubscription() {
        if (this.props.currentUser && this.props.currentUser.modalSubscribed && this.props.currentUser.modalSubscribed.modal) {
            this.setState({subscription: true});
        } else {
            history.push(this.props.currentUser.modalSubscribed.link);
        }
    };

    render(){
        return (
            <div id="subscribe">
                <div className="container card">
                    <h3>Abonnez vous pour aller plus loin sur <span>Voissa</span></h3>
                    <div className="advantage-container">
                        <div className="advantage-block">
                            <div className="icon-container">
                                <Icon type="pencil"/>
                            </div>
                            <div className="text-container">
                                <h4>Faire connaissance</h4>
                                <span className="text small">Ecrire à tous les voissanautes</span>
                            </div>
                        </div>
                        <div className="advantage-block">
                            <div className="icon-container">
                                <Icon type="speech-bubbles"/>
                            </div>
                            <div className="text-container">
                                <h4>Messagerie Instantanée</h4>
                                <span className="text small">Discuter en privé avec vos amis</span>
                            </div>
                        </div>
                        <div className="advantage-block">
                            <div className="icon-container">
                                <Icon type="user-plus"/>
                            </div>
                            <div className="text-container">
                                <h4>Amitié virtuelle</h4>
                                <span className="text small">Créer des relations entre Voissanautes</span>
                            </div>
                        </div>
                        <div className="advantage-block">
                            <div className="icon-container">
                                <Icon type="location-arrow"/>
                            </div>
                            <div className="text-container">
                                <h4>Rencontre par affinités</h4>
                                <span className="text small">Découvrir les membres proche de chez vous</span>
                            </div>
                        </div>
                        <div className="advantage-block">
                            <div className="icon-container">
                                <Icon type="bulhorn"/>
                            </div>
                            <div className="text-container">
                                <h4>Plans Rapides</h4>
                                <span className="text small">Publier et visionner les plans rapides des Voissanautes</span>
                            </div>
                        </div>
                        <div className="advantage-block">
                            <div className="icon-container">
                                <Icon type="video-camera"/>
                            </div>
                            <div className="text-container">
                                <h4>Chat Webcam</h4>
                                <span className="text small">Participer aux soirées coquines sur le chat-webcam</span>
                            </div>
                        </div>
                    </div>
                    <Button className={"mx-auto p-16"}
                            size={"medium"}
                            btnStyle={"primary-reverse"}
                            onClick={()=>this.onClickModalSubscription()}
                            content={"Commencer l'aventure Voissa"}/>
                </div>
                <Modal toggle={this.state.subscription}
                       handleClose={() => this.setState({subscription: false})}>
                    <ModalSubscription  handleClose={() => this.setState({subscription: false})} />
                </Modal>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Subscribe);
